import { ServiceClassId, ServiceClassResponse } from '@business/entities/project';
import { Endpoint } from '../endpoint';

export function fetchClasses() {
  return Endpoint.get<ServiceClassResponse[]>(`@gc/project-class`);
}

export function createClass(data: Partial<ServiceClassResponse>) {
  return Endpoint.post<ServiceClassResponse>(`@gc/project-class`, { data });
}

export function updateClass(id: ServiceClassId, data: Partial<ServiceClassResponse>) {
  return Endpoint.patch<ServiceClassResponse>(`@gc/project-class/${id}`, { data });
}

export function deleteClass(id: ServiceClassId) {
  return Endpoint.delete<ServiceClassResponse>(`@gc/project-class/${id}`);
}

export function updateSetting(invoiceRequired: boolean, invoiceHide: boolean) {
  return Endpoint.post<ServiceClassResponse>(`@gc/project-class/setting`, { data: { invoiceRequired, invoiceHide, invoiceEnabled: invoiceHide } });
}
